import * as React from 'react';
import { ca } from '@cian/analytics';
/**
 * Разметка: https://conf.cian.tech/pages/viewpage.action?pageId=1413840548
 */
export function useTracking(_ref) {
  var newbuildingId = _ref.newbuildingId,
    pageTypeJK = _ref.pageTypeJK,
    houseId = _ref.houseId;
  var page = React.useMemo(function () {
    var isSeoPage = pageTypeJK === 'Seo';
    var extra = {
      PageTypeJK: 'Normal'
    };
    if (isSeoPage) {
      extra.is_seo = true;
    }
    return {
      pageType: 'CardJK',
      siteType: 'mobile',
      extra: extra
    };
  }, [pageTypeJK]);

  /**
   * Старое событие, в статье не отсутствует, используется только в флоу с отключенной модалкой офферов
   */
  var trackListingLinkClick = React.useCallback(function (action) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_JK',
      action: action,
      label: 'layout',
      page: page,
      products: [{
        id: newbuildingId,
        offerType: 'JK',
        extra: {
          room_num: null,
          corpus_id: houseId || null
        }
      }]
    });
  }, [page, newbuildingId, houseId]);

  /**
   * Событие открытия модалки офферов (№2)
   */
  var trackLayoutModalOpen = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'show_sopr',
      label: 'modal_open',
      page: page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Старое событие перехода по ссылке на 3D тур, в статье отсутствует
   */
  var trackTourClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layouts',
      action: 'Сlick',
      label: '3dtour_viewer',
      page: page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Событие перехода в карточку объекта из модалки офферов (№3)
   */
  var trackFlatCardClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_card',
      page: page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Событие перехода из модалки листинг внутри ЖК (№4)
   */
  var trackHeaderLinkClick = React.useCallback(function () {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_listing_jk',
      page: page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);
  return React.useMemo(function () {
    return {
      trackListingLinkClick: trackListingLinkClick,
      trackLayoutModalOpen: trackLayoutModalOpen,
      trackFlatCardClick: trackFlatCardClick,
      trackHeaderLinkClick: trackHeaderLinkClick,
      trackTourClick: trackTourClick
    };
  }, [trackListingLinkClick, trackLayoutModalOpen, trackTourClick, trackFlatCardClick, trackHeaderLinkClick]);
}